import { render } from "./StageAdvertisingMix.vue?vue&type=template&id=22c8a31a&scoped=true"
import script from "./StageAdvertisingMix.vue?vue&type=script&lang=js"
export * from "./StageAdvertisingMix.vue?vue&type=script&lang=js"

import "./StageAdvertisingMix.vue?vue&type=style&index=0&id=22c8a31a&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c8a31a"]])

export default __exports__